// extracted by mini-css-extract-plugin
export const heroContainer = "index-module__heroContainer--35Ee6";
export const heroHeadline = "hero-headline";
export const heroDescription = "hero-description";
export const heroMedia = "hero-media";
export const actionContainer = "action-container";
export const cta = "cta";
export const secondary = "secondary";
export const contentBlock = "index-module__contentBlock--37OZ3";